/*
  Shoes Egy — Saved pairs (wishlist).

  Kept in this browser's localStorage as a list of product handles, newest
  first; no account needed, so it does not follow a customer to another
  device. Any [data-save="<handle>"] button toggles its product; every such
  button and every [data-saved-count] element is repainted after a change,
  and again whenever new markup arrives (Load more, a colour switch on the
  product page, the Saved page filling in) through a MutationObserver.

  The Saved page (sections/shoes-egy-wishlist.liquid) reads the list back
  through window.ShoesSaved.
*/
(function () {
  var KEY = 'shoesEgySaved';
  var MAX = 100;

  function read() {
    try {
      var list = JSON.parse(window.localStorage.getItem(KEY) || '[]');
      return Array.isArray(list) ? list.filter(function (h) { return typeof h === 'string' && h; }) : [];
    } catch (e) {
      return [];
    }
  }

  function write(list) {
    try { window.localStorage.setItem(KEY, JSON.stringify(list.slice(0, MAX))); } catch (e) { /* private mode */ }
    paint();
  }

  function paint() {
    var list = read();
    document.querySelectorAll('[data-save]').forEach(function (btn) {
      var on = list.indexOf(btn.getAttribute('data-save')) !== -1;
      if (btn.getAttribute('aria-pressed') !== String(on)) btn.setAttribute('aria-pressed', String(on));
    });
    document.querySelectorAll('[data-saved-count]').forEach(function (el) {
      if (el.textContent !== String(list.length)) el.textContent = String(list.length);
      el.classList.toggle('is-empty', list.length === 0);
    });
  }

  document.addEventListener('click', function (e) {
    var btn = e.target.closest('[data-save]');
    if (!btn) return;
    e.preventDefault();
    var handle = btn.getAttribute('data-save');
    var list = read();
    var at = list.indexOf(handle);
    if (at === -1) list.unshift(handle); else list.splice(at, 1);
    write(list);
  });

  var queued = false;
  function soon() {
    if (queued) return;
    queued = true;
    window.requestAnimationFrame(function () { queued = false; paint(); });
  }

  // another tab saving or removing
  window.addEventListener('storage', function (e) { if (e.key === KEY) paint(); });

  window.ShoesSaved = { read: read, write: write };

  function start() {
    paint();
    new MutationObserver(soon).observe(document.body, { childList: true, subtree: true });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start, { once: true });
  else start();
})();
